export default __webpack_public_path__ + "static/media/file-upload-success.693a01ae.svg";